import React from 'react';
import {
    IRendererResult,
    IResourceReactRenderer,
} from 'features/pi/view/resource/IResourceReactRenderer';
import { ImgResource } from 'features/pi/view/uiManager/img-resource/img-resource';

export class ImageResourceRenderer implements IResourceReactRenderer<string> {
    render(data: string): IRendererResult {
        return {
            content: <ImgResource src={data} />,
        };
    }
}
